import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as state from '../../../../../../../state'
import * as modals from '../../modals'

/** Component for displaying Space clusters. */
@ngCore.Component({
  imports: [
    ds.overlay.confirmation.Component,
    ds.table.Component,
    ds.layout.page.Component,
    modals.cluster.Component,
  ],
  selector: 'atn-space-clusters',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.full.clusters.Collection} */
  public readonly clustersEc = ngCore.inject(
    state.space.full.clusters.Collection,
  )

  /** Canonical table input for Space clusters. */
  public readonly tableConfig = {
    collection: this.clustersEc,
    view: {
      creation: () => this.addClusterClickHandler(),
      title: 'Clusters',
    },
  } satisfies ds.table.ec.Config.Input<state.space.full.clusters.TypeParams>

  /** Handle add cluster */
  public readonly addClusterClickHandler = (): void => {
    this.clustersEc.plugins.editingPlugin.feature.actions.edit
      .from('Clusters.Table.Add.Clicked')
      .dispatch({
        id: ec.plugins.standard.editing.models.CreationId.generate(),
      })
  }

  /** Confirms the deletion of the cluster marked for removal */
  public confirmDeletionClickHandler(): void {
    this.clustersEc.plugins.editingPlugin.feature.actions.submit
      .from('Clusters.Delete.Confirmation.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /** Cancels the deletion of the cluster marked for removal */
  public cancelDeletionClickHandler(): void {
    this.clustersEc.plugins.editingPlugin.feature.actions.discard
      .from('Clusters.Delete.Confirmation.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
